import {createReducer} from '@reduxjs/toolkit'
import {setInstance} from '../actions/instance'
import {decodeInstance} from '../selectors/instance'
import {InstanceState} from '../types/state'

const defaultState: InstanceState = {
  instance: null,
  visitorId: null,
  msid: null,
  instanceId: null,
  siteIsTemplate: false,
  demoMode: false,
  siteOwnerId: null,
}

export const instance = createReducer(defaultState, builder =>
  builder.addCase(setInstance, (_, action) => ({
    instance: action.payload,
    ...decodeInstance(action.payload),
  })),
)
